// @generated by protoc-gen-es v2.10.2 with parameter "target=js"
// @generated from file slorgproto/v1/wsc.proto (package slorgproto.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_slorgproto_v1_core } from "./core_pb";

/**
 * Describes the file slorgproto/v1/wsc.proto.
 */
export const file_slorgproto_v1_wsc = /*@__PURE__*/
  fileDesc("ChdzbG9yZ3Byb3RvL3YxL3dzYy5wcm90bxINc2xvcmdwcm90by52MSJyChFXU0NTZWFyY2hSZXNwb25zZRIsCgVub2RlcxgBIAMoCzIdLnNsb3JncHJvdG8udjEuRmlsZVN5c3RlbU5vZGUSLwoHcmVzdWx0cxgCIAMoCzIeLnNsb3JncHJvdG8udjEuV1NDU2VhcmNoUmVzdWx0IpIBCg9XU0NTZWFyY2hSZXN1bHQSKwoEbm9kZRgBIAEoCzIdLnNsb3JncHJvdG8udjEuRmlsZVN5c3RlbU5vZGUSDQoFc2NvcmUYAiABKAISDwoHc25pcHBldBgDIAEoCRIyCgptYXRjaF9raW5kGAQgASgOMh4uc2xvcmdwcm90by52MS5TZWFyY2hNYXRjaEtpbmQiNgoMT3JnYW5pemF0aW9uEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSDAoEc2x1ZxgDIAEoCSJiChZPcmdhbml6YXRpb25NZW1iZXJzaGlwEhUKDW1lbWJlcnNoaXBfaWQYASABKAkSMQoMb3JnYW5pemF0aW9uGAIgASgLMhsuc2xvcmdwcm90by52MS5Pcmdhbml6YXRpb24iHQobR2V0VXNlck9yZ2FuaXphdGlvbnNSZXF1ZXN0IloKHEdldFVzZXJPcmdhbml6YXRpb25zUmVzcG9uc2USOgoLbWVtYmVyc2hpcHMYASADKAsyJS5zbG9yZ3Byb3RvLnYxLk9yZ2FuaXphdGlvbk1lbWJlcnNoaXAifAoUR2V0V3NjU3RhdHVzUmVzcG9uc2USDgoGc3RhdHVzGAEgASgJEg8KB3ZlcnNpb24YAiABKAkSQwoYYWxsb3dlZF9zdG9yYWdlX2JhY2tlbmRzGAMgAygOMiEuc2xvcmdwcm90by52MS5TdG9yYWdlQmFja2VuZFR5cGUiPgoNU2lnbnVwUmVxdWVzdBINCgVlbWFpbBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRIMCgRuYW1lGAMgASgJIiEKDlNpZ251cFJlc3BvbnNlEg8KB3VzZXJfaWQYASABKAkiKwoXV3NjRGVsZXRlQWNjb3VudFJlcXVlc3QSEAoIcGFzc3dvcmQYASABKAkiJgoYV3NjRGVsZXRlQWNjb3VudFJlc3BvbnNlEgoKAm9rGAEgASgIIjEKDEJhY2tsaW5rSW5mbxIQCghzbG9yZ19pZBgBIAEoCRIPCgdoZWFkaW5nGAIgASgJIkYKFEdldEJhY2tsaW5rc1Jlc3BvbnNlEi4KCWJhY2tsaW5rcxgBIAMoCzIbLnNsb3JncHJvdG8udjEuQmFja2xpbmtJbmZvIlYKF1dzY0dldEFzc2V0SW5mb1Jlc3BvbnNlEicKBWFzc2V0GAEgASgLMhguc2xvcmdwcm90by52MS5Bc3NldEluZm8SEgoKc2lnbmVkX3VybBgCIAEoCSInChlXc2NEZWxldGVEb2N1bWVudFJlc3BvbnNlEgoKAm9rGAEgASgIIiUKF1dzY0RlbGV0ZUNvbmZpZ1Jlc3BvbnNlEgoKAm9rGAEgASgIIk8KGldzY0RlbGV0ZURpcmVjdG9yeVJlc3BvbnNlEgoKAm9rGAEgASgIEg8KB21lc3NhZ2UYAiABKAkSFAoMZGVsZXRlZF9wYXRoGAMgASgJIvkCChBEb2N1bWVudFRlbXBsYXRlEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkSDwoHaGVhZGluZxgDIAEoCRIYChB0YXJnZXRfZGlyZWN0b3J5GAQgASgJEiUKBnN0YXR1cxgFIAEoDjIVLnNsb3JncHJvdG8udjEuU3RhdHVzEgwKBHRhZ3MYBiADKAkSMwoKcHJvcGVydGllcxgHIAMoCzIfLnNsb3JncHJvdG8udjEuRGVjbGFyZWRQcm9wZXJ0eRIRCglib2R5X3RleHQYCCABKAkSKQoIcHJpb3JpdHkYCSABKA4yFy5zbG9yZ3Byb3RvLnYxLlByaW9yaXR5EhcKD2xpbmtfdG9fam91cm5hbBgKIAEoCBIYChBwcm9tcHRfc2NoZWR1bGVkGAsgASgIEhcKD3Byb21wdF9kZWFkbGluZRgMIAEoCBITCgtwcm9tcHRfYm9keRgNIAEoCBIXCg9wcm9tcHRfcHJpb3JpdHkYDiABKAgiUwodTGlzdERvY3VtZW50VGVtcGxhdGVzUmVzcG9uc2USMgoJdGVtcGxhdGVzGAEgAygLMh8uc2xvcmdwcm90by52MS5Eb2N1bWVudFRlbXBsYXRlIi8KIVdzY0RlbGV0ZURvY3VtZW50VGVtcGxhdGVSZXNwb25zZRIKCgJvaxgBIAEoCCIjChNXc2NMaXN0VGFnc1Jlc3BvbnNlEgwKBHRhZ3MYASADKAki/wMKIUNyZWF0ZURvY3VtZW50RnJvbVRlbXBsYXRlUmVxdWVzdBITCgt0ZW1wbGF0ZV9pZBgBIAEoCRIPCgdoZWFkaW5nGAIgASgJEmUKE3Byb21wdGVkX3Byb3BlcnRpZXMYAyADKAsySC5zbG9yZ3Byb3RvLnYxLkNyZWF0ZURvY3VtZW50RnJvbVRlbXBsYXRlUmVxdWVzdC5Qcm9tcHRlZFByb3BlcnRpZXNFbnRyeRIdChB0YXJnZXRfZGlyZWN0b3J5GAQgASgJSACIAQESFgoJYm9keV90ZXh0GAUgASgJSAGIAQESMAoJc2NoZWR1bGVkGAYgASgLMhguc2xvcmdwcm90by52MS5TY2hlZHVsZWRIAogBARIuCghkZWFkbGluZRgHIAEoCzIXLnNsb3JncHJvdG8udjEuRGVhZGxpbmVIA4gBARIuCghwcmlvcml0eRgIIAEoDjIXLnNsb3JncHJvdG8udjEuUHJpb3JpdHlIBIgBARo5ChdQcm9tcHRlZFByb3BlcnRpZXNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQhMKEV90YXJnZXRfZGlyZWN0b3J5QgwKCl9ib2R5X3RleHRCDAoKX3NjaGVkdWxlZEILCglfZGVhZGxpbmVCCwoJX3ByaW9yaXR5IqYBCgtRdWlja0FkZFRhYhIKCgJpZBgBIAEoCRITCgt0ZW1wbGF0ZV9pZBgCIAEoCRINCgVsYWJlbBgDIAEoCRIrCgVzaGFwZRgEIAEoDjIcLnNsb3JncHJvdG8udjEuUXVpY2tBZGRTaGFwZRIrCgVjb2xvchgFIAEoDjIcLnNsb3JncHJvdG8udjEuUXVpY2tBZGRDb2xvchINCgVvcmRlchgGIAEoBSJEChhMaXN0UXVpY2tBZGRUYWJzUmVzcG9uc2USKAoEdGFicxgBIAMoCzIaLnNsb3JncHJvdG8udjEuUXVpY2tBZGRUYWIiLQoaUmVvcmRlclF1aWNrQWRkVGFic1JlcXVlc3QSDwoHdGFiX2lkcxgBIAMoCSIqChxXc2NEZWxldGVRdWlja0FkZFRhYlJlc3BvbnNlEgoKAm9rGAEgASgIIrgBCgNKb2ISCgoCaWQYASABKAkSJAoEa2luZBgCIAEoDjIWLnNsb3JncHJvdG8udjEuSm9iS2luZBImCgVzdGF0ZRgDIAEoDjIXLnNsb3JncHJvdG8udjEuSm9iU3RhdGUSGAoQcHJvZ3Jlc3NfY3VycmVudBgEIAEoBRIWCg5wcm9ncmVzc190b3RhbBgFIAEoBRIWCg5zdGF0dXNfbWVzc2FnZRgGIAEoCRINCgVlcnJvchgHIAEoCSJRChBEaWdlc3RUaW1lT3B0aW9uEicKBHRpbWUYASABKA4yGS5zbG9yZ3Byb3RvLnYxLkRpZ2VzdFRpbWUSFAoMbG9jYWxfbWludXRlGAIgASgFIkYKFE5vdGlmaWNhdGlvblNldHRpbmdzEi4KC2RpZ2VzdF90aW1lGAEgASgOMhkuc2xvcmdwcm90by52MS5EaWdlc3RUaW1lIpIBChBQdXNoU3Vic2NyaXB0aW9uEgoKAmlkGAEgASgJEhAKCGVuZHBvaW50GAIgASgJEhIKCnB1YmxpY19rZXkYAyABKAkSEwoLYXV0aF9zZWNyZXQYBCABKAkSEAoIdGltZXpvbmUYBSABKAkSDwoHZW5hYmxlZBgGIAEoCBIUCgxkZXZpY2VfbGFiZWwYByABKAki4QEKH0dldE5vdGlmaWNhdGlvblNldHRpbmdzUmVzcG9uc2USNQoIc2V0dGluZ3MYASABKAsyIy5zbG9yZ3Byb3RvLnYxLk5vdGlmaWNhdGlvblNldHRpbmdzEjUKDGRpZ2VzdF90aW1lcxgCIAMoCzIfLnNsb3JncHJvdG8udjEuRGlnZXN0VGltZU9wdGlvbhI2Cg1zdWJzY3JpcHRpb25zGAMgAygLMh8uc2xvcmdwcm90by52MS5QdXNoU3Vic2NyaXB0aW9uEhgKEHZhcGlkX3B1YmxpY19rZXkYBCABKAkiLwohV3NjRGVsZXRlUHVzaFN1YnNjcmlwdGlvblJlc3BvbnNlEgoKAm9rGAEgASgIIiUKF1dzY1NlbmRUZXN0UHVzaFJlc3BvbnNlEgoKAm9rGAEgASgIKqgBCg9TZWFyY2hNYXRjaEtpbmQSIQodU0VBUkNIX01BVENIX0tJTkRfVU5TUEVDSUZJRUQQABIeChpTRUFSQ0hfTUFUQ0hfS0lORF9TTE9SR19JRBABEhsKF1NFQVJDSF9NQVRDSF9LSU5EX1RJVExFEAISGQoVU0VBUkNIX01BVENIX0tJTkRfVEFHEAMSGgoWU0VBUkNIX01BVENIX0tJTkRfQk9EWRAEKqMBCg1RdWlja0FkZFNoYXBlEh8KG1FVSUNLX0FERF9TSEFQRV9VTlNQRUNJRklFRBAAEhUKEVFVSUNLX0FERF9TSEFQRV8xEAESFQoRUVVJQ0tfQUREX1NIQVBFXzIQAhIVChFRVUlDS19BRERfU0hBUEVfMxADEhUKEVFVSUNLX0FERF9TSEFQRV80EAQSFQoRUVVJQ0tfQUREX1NIQVBFXzUQBSqjAQoNUXVpY2tBZGRDb2xvchIfChtRVUlDS19BRERfQ09MT1JfVU5TUEVDSUZJRUQQABIVChFRVUlDS19BRERfQ09MT1JfMRABEhUKEVFVSUNLX0FERF9DT0xPUl8yEAISFQoRUVVJQ0tfQUREX0NPTE9SXzMQAxIVChFRVUlDS19BRERfQ09MT1JfNBAEEhUKEVFVSUNLX0FERF9DT0xPUl81EAUqPwoHSm9iS2luZBIYChRKT0JfS0lORF9VTlNQRUNJRklFRBAAEhoKFkpPQl9LSU5EX0NBQ0hFX1JFQlVJTEQQASqzAQoISm9iU3RhdGUSGQoVSk9CX1NUQVRFX1VOU1BFQ0lGSUVEEAASFQoRSk9CX1NUQVRFX1BFTkRJTkcQARIVChFKT0JfU1RBVEVfUlVOTklORxACEhcKE0pPQl9TVEFURV9DQU5DRUxJTkcQAxIXChNKT0JfU1RBVEVfU1VDQ0VFREVEEAQSFAoQSk9CX1NUQVRFX0ZBSUxFRBAFEhYKEkpPQl9TVEFURV9DQU5DRUxFRBAGKr8BCgpEaWdlc3RUaW1lEhsKF0RJR0VTVF9USU1FX1VOU1BFQ0lGSUVEEAASGAoURElHRVNUX1RJTUVfREFZQlJFQUsQARIXChNESUdFU1RfVElNRV9NT1JOSU5HEAISFgoSRElHRVNUX1RJTUVfTUlEREFZEAMSGQoVRElHRVNUX1RJTUVfQUZURVJOT09OEAQSFwoTRElHRVNUX1RJTUVfRVZFTklORxAFEhUKEURJR0VTVF9USU1FX05JR0hUEAZCDVoLL3Nsb3JncHJvdG9iBnByb3RvMw", [file_slorgproto_v1_core]);

/**
 * Describes the message slorgproto.v1.WSCSearchResponse.
 * Use `create(WSCSearchResponseSchema)` to create a new message.
 */
export const WSCSearchResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 0);

/**
 * Describes the message slorgproto.v1.WSCSearchResult.
 * Use `create(WSCSearchResultSchema)` to create a new message.
 */
export const WSCSearchResultSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 1);

/**
 * Describes the message slorgproto.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 2);

/**
 * Describes the message slorgproto.v1.OrganizationMembership.
 * Use `create(OrganizationMembershipSchema)` to create a new message.
 */
export const OrganizationMembershipSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 3);

/**
 * Describes the message slorgproto.v1.GetUserOrganizationsRequest.
 * Use `create(GetUserOrganizationsRequestSchema)` to create a new message.
 */
export const GetUserOrganizationsRequestSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 4);

/**
 * Describes the message slorgproto.v1.GetUserOrganizationsResponse.
 * Use `create(GetUserOrganizationsResponseSchema)` to create a new message.
 */
export const GetUserOrganizationsResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 5);

/**
 * Describes the message slorgproto.v1.GetWscStatusResponse.
 * Use `create(GetWscStatusResponseSchema)` to create a new message.
 */
export const GetWscStatusResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 6);

/**
 * Describes the message slorgproto.v1.SignupRequest.
 * Use `create(SignupRequestSchema)` to create a new message.
 */
export const SignupRequestSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 7);

/**
 * Describes the message slorgproto.v1.SignupResponse.
 * Use `create(SignupResponseSchema)` to create a new message.
 */
export const SignupResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 8);

/**
 * Describes the message slorgproto.v1.WscDeleteAccountRequest.
 * Use `create(WscDeleteAccountRequestSchema)` to create a new message.
 */
export const WscDeleteAccountRequestSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 9);

/**
 * Describes the message slorgproto.v1.WscDeleteAccountResponse.
 * Use `create(WscDeleteAccountResponseSchema)` to create a new message.
 */
export const WscDeleteAccountResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 10);

/**
 * Describes the message slorgproto.v1.BacklinkInfo.
 * Use `create(BacklinkInfoSchema)` to create a new message.
 */
export const BacklinkInfoSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 11);

/**
 * Describes the message slorgproto.v1.GetBacklinksResponse.
 * Use `create(GetBacklinksResponseSchema)` to create a new message.
 */
export const GetBacklinksResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 12);

/**
 * Describes the message slorgproto.v1.WscGetAssetInfoResponse.
 * Use `create(WscGetAssetInfoResponseSchema)` to create a new message.
 */
export const WscGetAssetInfoResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 13);

/**
 * Describes the message slorgproto.v1.WscDeleteDocumentResponse.
 * Use `create(WscDeleteDocumentResponseSchema)` to create a new message.
 */
export const WscDeleteDocumentResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 14);

/**
 * Describes the message slorgproto.v1.WscDeleteConfigResponse.
 * Use `create(WscDeleteConfigResponseSchema)` to create a new message.
 */
export const WscDeleteConfigResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 15);

/**
 * Describes the message slorgproto.v1.WscDeleteDirectoryResponse.
 * Use `create(WscDeleteDirectoryResponseSchema)` to create a new message.
 */
export const WscDeleteDirectoryResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 16);

/**
 * Describes the message slorgproto.v1.DocumentTemplate.
 * Use `create(DocumentTemplateSchema)` to create a new message.
 */
export const DocumentTemplateSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 17);

/**
 * Describes the message slorgproto.v1.ListDocumentTemplatesResponse.
 * Use `create(ListDocumentTemplatesResponseSchema)` to create a new message.
 */
export const ListDocumentTemplatesResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 18);

/**
 * Describes the message slorgproto.v1.WscDeleteDocumentTemplateResponse.
 * Use `create(WscDeleteDocumentTemplateResponseSchema)` to create a new message.
 */
export const WscDeleteDocumentTemplateResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 19);

/**
 * Describes the message slorgproto.v1.WscListTagsResponse.
 * Use `create(WscListTagsResponseSchema)` to create a new message.
 */
export const WscListTagsResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 20);

/**
 * Describes the message slorgproto.v1.CreateDocumentFromTemplateRequest.
 * Use `create(CreateDocumentFromTemplateRequestSchema)` to create a new message.
 */
export const CreateDocumentFromTemplateRequestSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 21);

/**
 * Describes the message slorgproto.v1.QuickAddTab.
 * Use `create(QuickAddTabSchema)` to create a new message.
 */
export const QuickAddTabSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 22);

/**
 * Describes the message slorgproto.v1.ListQuickAddTabsResponse.
 * Use `create(ListQuickAddTabsResponseSchema)` to create a new message.
 */
export const ListQuickAddTabsResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 23);

/**
 * Describes the message slorgproto.v1.ReorderQuickAddTabsRequest.
 * Use `create(ReorderQuickAddTabsRequestSchema)` to create a new message.
 */
export const ReorderQuickAddTabsRequestSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 24);

/**
 * Describes the message slorgproto.v1.WscDeleteQuickAddTabResponse.
 * Use `create(WscDeleteQuickAddTabResponseSchema)` to create a new message.
 */
export const WscDeleteQuickAddTabResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 25);

/**
 * Describes the message slorgproto.v1.Job.
 * Use `create(JobSchema)` to create a new message.
 */
export const JobSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 26);

/**
 * Describes the message slorgproto.v1.DigestTimeOption.
 * Use `create(DigestTimeOptionSchema)` to create a new message.
 */
export const DigestTimeOptionSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 27);

/**
 * Describes the message slorgproto.v1.NotificationSettings.
 * Use `create(NotificationSettingsSchema)` to create a new message.
 */
export const NotificationSettingsSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 28);

/**
 * Describes the message slorgproto.v1.PushSubscription.
 * Use `create(PushSubscriptionSchema)` to create a new message.
 */
export const PushSubscriptionSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 29);

/**
 * Describes the message slorgproto.v1.GetNotificationSettingsResponse.
 * Use `create(GetNotificationSettingsResponseSchema)` to create a new message.
 */
export const GetNotificationSettingsResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 30);

/**
 * Describes the message slorgproto.v1.WscDeletePushSubscriptionResponse.
 * Use `create(WscDeletePushSubscriptionResponseSchema)` to create a new message.
 */
export const WscDeletePushSubscriptionResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 31);

/**
 * Describes the message slorgproto.v1.WscSendTestPushResponse.
 * Use `create(WscSendTestPushResponseSchema)` to create a new message.
 */
export const WscSendTestPushResponseSchema = /*@__PURE__*/
  messageDesc(file_slorgproto_v1_wsc, 32);

/**
 * Describes the enum slorgproto.v1.SearchMatchKind.
 */
export const SearchMatchKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 0);

/**
 * @generated from enum slorgproto.v1.SearchMatchKind
 */
export const SearchMatchKind = /*@__PURE__*/
  tsEnum(SearchMatchKindSchema);

/**
 * Describes the enum slorgproto.v1.QuickAddShape.
 */
export const QuickAddShapeSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 1);

/**
 * @generated from enum slorgproto.v1.QuickAddShape
 */
export const QuickAddShape = /*@__PURE__*/
  tsEnum(QuickAddShapeSchema);

/**
 * Describes the enum slorgproto.v1.QuickAddColor.
 */
export const QuickAddColorSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 2);

/**
 * @generated from enum slorgproto.v1.QuickAddColor
 */
export const QuickAddColor = /*@__PURE__*/
  tsEnum(QuickAddColorSchema);

/**
 * Describes the enum slorgproto.v1.JobKind.
 */
export const JobKindSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 3);

/**
 * @generated from enum slorgproto.v1.JobKind
 */
export const JobKind = /*@__PURE__*/
  tsEnum(JobKindSchema);

/**
 * Describes the enum slorgproto.v1.JobState.
 */
export const JobStateSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 4);

/**
 * @generated from enum slorgproto.v1.JobState
 */
export const JobState = /*@__PURE__*/
  tsEnum(JobStateSchema);

/**
 * Describes the enum slorgproto.v1.DigestTime.
 */
export const DigestTimeSchema = /*@__PURE__*/
  enumDesc(file_slorgproto_v1_wsc, 5);

/**
 * @generated from enum slorgproto.v1.DigestTime
 */
export const DigestTime = /*@__PURE__*/
  tsEnum(DigestTimeSchema);

